import { Link } from "react-router-dom";
import { Linkedin, Mail, Phone, ArrowUpRight } from "lucide-react";
import { COMPANY, NAV_LINKS, OFFICES } from "@/constants/siteData";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="relative bg-ink text-white mt-24 overflow-hidden">
      <div aria-hidden className="pointer-events-none absolute inset-0 opacity-70">
        <div className="absolute -top-40 -left-40 h-[520px] w-[520px] rounded-full bg-[#1E5AF6]/30 blur-[120px] aurora" />
        <div className="absolute top-20 -right-40 h-[460px] w-[460px] rounded-full bg-[#16A374]/25 blur-[120px] aurora" />
      </div>
      <div className="container-page py-20 relative">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-3">
            <div className="flex items-center gap-2 mb-6">
              <span className="relative inline-block h-3 w-3 overflow-hidden">
                <span className="absolute inset-0 bg-gradient-to-br from-[#1E5AF6] to-[#16A374]" />
              </span>
              <span className="font-display font-extrabold text-2xl">DigiTrans</span>
            </div>
            <p className="text-[#a1a1aa] max-w-md text-base leading-relaxed">
              Delivering clarity in a cluttered business environment. Digital,
              Technology, Data &amp; AI advisory for organizations building
              what&apos;s next.
            </p>
            <a
              href={COMPANY.linkedin}
              target="_blank"
              rel="noreferrer"
              data-testid="footer-linkedin"
              className="inline-flex items-center gap-2 mt-8 text-sm border border-white/20 px-4 py-2 hover:bg-white hover:text-black transition-colors"
            >
              <Linkedin className="w-4 h-4" /> Follow on LinkedIn
              <ArrowUpRight className="w-4 h-4" />
            </a>
          </div>

          <div className="md:col-span-4">
            <p className="eyebrow text-white/60 mb-4">Offices</p>
            <ul className="grid grid-cols-2 gap-3">
              {OFFICES.map((o) => (
                <li
                  key={o.key}
                  data-testid={`footer-office-${o.key}`}
                  className="border border-white/10 p-3"
                >
                  <span
                    className="inline-block h-1.5 w-6 mb-2"
                    style={{ background: o.color }}
                  />
                  <p className="font-display font-bold text-sm leading-tight">
                    {o.city}
                  </p>
                  <p className="text-[11px] text-white/60 leading-tight mt-0.5">
                    {o.country}
                  </p>
                  <p className="text-[10px] font-mono uppercase tracking-[0.16em] text-white/40 mt-1">
                    {o.label}
                  </p>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <p className="eyebrow text-white/60 mb-4">Navigate</p>
            <ul className="space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.id}>
                  <Link
                    to={l.to}
                    data-testid={`footer-link-${l.id}`}
                    className="text-white/90 hover:text-white text-base link-underline"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="eyebrow text-white/60 mb-4">Contact</p>
            <ul className="space-y-4 text-white/85 text-base">
              <li className="flex items-center gap-3">
                <Phone className="w-4 h-4 shrink-0 text-[#1E5AF6]" />
                <a
                  data-testid="footer-phone"
                  href={COMPANY.phoneHref}
                  className="whitespace-nowrap hover:text-white link-underline"
                >
                  {COMPANY.phone}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-4 h-4 shrink-0 text-[#1E5AF6]" />
                <a
                  data-testid="footer-email"
                  href={`mailto:${COMPANY.email}`}
                  className="whitespace-nowrap hover:text-white link-underline"
                >
                  {COMPANY.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-sm text-white/50">
          <p>
            © {year} DigiTrans Technology FZE. All rights reserved.
          </p>
          <p className="font-mono text-xs tracking-widest uppercase">
            Digital · Technology · Data · <span className="text-[#23D89A]">AI</span>
          </p>
        </div>
      </div>
    </footer>
  );
}
